import {Component, OnInit, Renderer2} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import { ApiFeedbackComponent } from '@/shared/ui/api-feedback.component';
import {filter, map, mergeMap} from 'rxjs';


@Component({
  standalone: true,          // marca como standalone
  selector: 'app-root',
  imports: [RouterOutlet, ApiFeedbackComponent],
  template: `
    <router-outlet></router-outlet>
    <app-api-feedback></app-api-feedback>
  `
})
export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private activated: ActivatedRoute,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(() => this.activated),
      map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      mergeMap(route => route.data)
    )
      .subscribe(data => {
        const bg = data['bg'] ?? '#ffffff';
        this.renderer.setStyle(document.body, 'backgroundColor', bg);
      });
  }
}
